import { normalizeTikTokVideoUrl } from "../../../extractor/tiktok-embed-extractor";
import { CardPreviewMediaAreaRender } from "./card-preview-media-area-render";
import { CardPreviewTileRender } from "./card-preview-tile-render";
import type { DetectedLinksMap } from "../../../core/sns-detector";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";

export class TikTokCardPreviewRender {
    public static addTikTokPreviewToCard(cardElement: Element, detectedLinks: DetectedLinksMap): void {
        if (!detectedLinks.tiktok?.length) return;

        const boardMediaArea = CardPreviewMediaAreaRender.findCardMediaArea(cardElement);
        if (!boardMediaArea) return;

        const placeholder = snsPreviewManagerForm.getBoardMediaPlaceholder(boardMediaArea);
        if (!placeholder) return;

        const existing = snsPreviewManagerForm.getExistingPrimaryPreview(boardMediaArea);
        if (existing) return;

        const tiktokUrl = String(detectedLinks.tiktok[0]?.url || "");
        const normalized = normalizeTikTokVideoUrl(tiktokUrl) || tiktokUrl;
        if (!normalized.includes("tiktok.com")) return;

        placeholder.remove();
        CardPreviewTileRender.renderIndexSnsTilePreview(boardMediaArea, normalized);
    }
}
